import { create } from "zustand";

type DilemmasFilterState = {
  searchValue: string | null;
  statusFilter: string | null;
  ordering: string | null;
  languageFilter: "fr" | "en" | null;
  themeFilter: string | null;
  aiGeneratedFilter: boolean | null;
  setSearchValue: (searchValue: string | null) => void;
  setStatusFilter: (status: string | null) => void;
  setOrdering: (ordering: string | null) => void;
  setLanguageFilter: (language: "fr" | "en" | null) => void;
  setThemeFilter: (themeId: string | null) => void;
  setAiGeneratedFilter: (value: boolean | null) => void;
};

export const useDilemmasFilterStore = create<DilemmasFilterState>((set) => ({
  searchValue: null,
  statusFilter: null,
  ordering: "-created_at",
  languageFilter: null,
  themeFilter: null,
  aiGeneratedFilter: null,
  setSearchValue: (searchValue) => set({ searchValue }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setOrdering: (ordering) => set({ ordering }),
  setLanguageFilter: (languageFilter) => set({ languageFilter }),
  setThemeFilter: (themeFilter) => set({ themeFilter }),
  setAiGeneratedFilter: (aiGeneratedFilter) => set({ aiGeneratedFilter }),
}));

type SubmissionsFilterState = {
  searchValue: string | null;
  statusFilter: string | null;
  ordering: string | null;
  languageFilter: "fr" | "en" | null;
  themeFilter: string | null;
  setSearchValue: (searchValue: string | null) => void;
  setStatusFilter: (status: string | null) => void;
  setOrdering: (ordering: string | null) => void;
  setLanguageFilter: (language: "fr" | "en" | null) => void;
  setThemeFilter: (themeId: string | null) => void;
};

export const useSubmissionsFilterStore = create<SubmissionsFilterState>(
  (set) => ({
    searchValue: null,
    statusFilter: null,
    ordering: "-created_at",
    languageFilter: null,
    themeFilter: null,
    setSearchValue: (searchValue) => set({ searchValue }),
    setStatusFilter: (statusFilter) => set({ statusFilter }),
    setOrdering: (ordering) => set({ ordering }),
    setLanguageFilter: (languageFilter) => set({ languageFilter }),
    setThemeFilter: (themeFilter) => set({ themeFilter }),
  }),
);
